import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { Drawer } from 'antd';
import AnalyticsLineGraph from './AnalyticsLineGraph';
import AnalyticsBarGraph from './AnalyticsBarGraph';
import apiCalls from 'src/api/apiCalls';
import { useLocation } from 'react-router-dom';
import { getAnalyticsExperience, getAnalyticsMovementChart, getAnalyticsYearLu } from './service';
import Loader from '../loader.component';
import SelectInput from '../shared/selectInput';
import AnalyticsKpi from 'src/blades/analyticsKpi';
const controllers = {
  customers: {
    yearsLu: "CustomerYearsLu",
    experience: "CustomerExperience",
    movement: "CustomerMovement"
  },
  cards: {
    yearsLu: "CardsYearsLu",
    experience: "CardsExperience",
    movement: "CardsMovement"
  },
}

const AnalyticsDrawer = ({ isVisible, onClose }) => {
  const location = useLocation();
  const [state, setState] = useState({
    loader: false,
    transactionLoader: false,
    movementLoader: false,
    error: null,
    kpiDetails: [],
    transactions: null,
    movementChart: null,
    yearLu: [],
    transactionsSelectedYear: new Date().getFullYear(),
    movementSelectedYear: new Date().getFullYear(),
  });
  const currentPath = location?.pathname?.replace('/', '');
  const controller = controllers[currentPath];

  useEffect(() => {
    fetchAnalyticsData();
  }, []);

  const fetchAnalyticsData = async () => {
    setState(prev => ({ ...prev, loader: true, error: apiCalls.isErrorDispaly(null) }));
    try {
      const [experienceRes, yearsLuRes, movementRes] = await Promise.all([
        getAnalyticsExperience(controller?.experience, state.transactionsSelectedYear),
        getAnalyticsYearLu(controller?.yearsLu),
        getAnalyticsMovementChart(controller?.movement, state.movementSelectedYear),
      ]);

      setState(prev => ({
        ...prev,
        yearLu: yearsLuRes?.data || [],
        kpiDetails: experienceRes.data?.kpis || experienceRes.error,
        transactions: experienceRes.data || experienceRes.error,
        movementChart: movementRes.data || movementRes.error,
      }));
    } catch (error) {
      setState(prev => ({ ...prev, error: apiCalls.isErrorDispaly(error.message) }));
    } finally {
      setState(prev => ({ ...prev, loader: false }));
    }
  };
  const handleYearChange = async (type, year) => {
    setState(prev => ({
      ...prev,
      [`${type}Loader`]: true,
      error: null,
    }));

    try {
      let response;
      if (type === 'transactions') {
        response = await getAnalyticsExperience(controller?.experience, year);
        setState(prev => ({
          ...prev,
          kpiDetails: response.data?.kpis || response.error,
          transactions: response.data || response.error,
        }));
      } else if (type === 'movement') {
        response = await getAnalyticsMovementChart(controller?.movement, year);
        setState(prev => ({
          ...prev,
          movementChart: response.data || response.error,
        }));
      }
    } catch (error) {
      setState(prev => ({ ...prev, error: apiCalls.isErrorDispaly(error.message) }));
    } finally {
      setState(prev => ({ ...prev, [`${type}Loader`]: false }));
    }
  };


  return (
    <Drawer
      title="Analytics"
      placement="right"
      onClose={onClose}
      open={isVisible}
      className='!bg-light-reportBG '
    >
      {state?.loader && <Loader />}
      {!state?.loader && <>
        <div className='mb-2 w-32 ml-auto'>
          <SelectInput
            showSearch={false}
            allowClear={false}
            options={state.yearLu}
            onChange={(year) => handleYearChange('transactions', year)}
            defaultValue={state?.transactionsSelectedYear}
          /></div>
        <AnalyticsKpi
          module="crypto"
          customClass='grid-cols-2 gap-4'
          shouldFetch={false}
          kpiDetails={state.kpiDetails}
          loader={state?.transactionLoader}
        />
         <hr className='my-4 opacity-20' />
        <AnalyticsLineGraph
          seriesData={state.transactions}
          loader={state?.transactionLoader}
        />
        <hr className='my-4 opacity-20' />
        <AnalyticsBarGraph
          seriesData={state.movementChart}
          yearLu={state.yearLu}
          onYearChange={(year) => handleYearChange('movement', year)}
          selectedYear={state?.movementSelectedYear}
        />
      </>}
    </Drawer>
  );
};

AnalyticsDrawer.propTypes = {
  isVisible: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  controller: PropTypes.object.isRequired,
};

export default AnalyticsDrawer;